import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Country } from '@modules/country/models/country.model';
import { MatDialog } from "@angular/material/dialog";
import { BillingAddressService } from "@modules/address/services/billing-address.service";
import {
  AddressCardComponent,
} from "@shared/component/common/address-card/address-card.component";
import { CommonModule } from "@angular/common";
import { MatCardModule } from "@angular/material/card";
import { OrderSummaryComponent } from "@shared/component/payments/components/order-summary/order-summary.component";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
  EmptyBillingAddressComponent
} from "@modules/account-settings/common/components/empty-billing-address/empty-billing-address.component";
import { SharedComponentModule } from "@shared/component/component.module";
import { LetModule } from "@ngrx/component";
import { OrderData } from "@shared/component/payments/components/order-summary/order-summary.type";
import { BillingAddress } from '@modules/address/models/billing-address.model';
import {
  CheckoutFlowFacadeService,
} from '@shared/component/payments/services/checkout-flow-facade.service';
import {
  CheckoutPromotionPanelComponent
} from '@shared/component/payments/components/checkout-promotion-panel/checkout-promotion-panel.component';

@Component({
  standalone: true,
  imports: [CommonModule, MatCardModule, OrderSummaryComponent, MatIconModule, MatProgressSpinnerModule, AddressCardComponent, EmptyBillingAddressComponent, SharedComponentModule, LetModule, CheckoutPromotionPanelComponent],
  selector: 'app-checkout-page',
  templateUrl: './checkout-page.component.html',
  styleUrls: ['./checkout-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CheckoutFlowFacadeService],
})
export class CheckoutPageComponent {
  @Input() country: Country;
  @Input() redirectUrl: any[];
  @Input() redirectQueryParams?: Record<string, string>;
  @Input() shouldRedirect = true;
  @Input() set orderData(value: OrderData) {
    this._orderData = value;
    this.checkoutFlowFacade.setOrderData(value ?? null);
  }
  get orderData(): OrderData {
    return this._orderData;
  }

  readonly vm$ = this.checkoutFlowFacade.vm$;
  readonly activeUser$ = this.checkoutFlowFacade.activeUser$;
  readonly selectedBillingAddress$ = this.checkoutFlowFacade.selectedBillingAddress$;
  readonly addressCardComponentConfig$ = this.checkoutFlowFacade.addressCardComponentConfig$;
  private _orderData: OrderData;

  constructor(
    private readonly dialog: MatDialog,
    private readonly billingAddressService: BillingAddressService,
    private readonly checkoutFlowFacade: CheckoutFlowFacadeService,
  ) {
  }

  onAddNewAddress() {
    return this.billingAddressService.onAddNewAddress(this.dialog);
  }

  setSelectedBillingAddress(address: BillingAddress | null) {
    this.checkoutFlowFacade.setSelectedBillingAddress(address);
  }

  changeSelectedAddress(address: BillingAddress | null) {
    if (address instanceof BillingAddress) {
      this.setSelectedBillingAddress(address);
    }
  }
}
